"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ThemeActions;
(function (ThemeActions) {
    ThemeActions["update"] = "theme.update";
})(ThemeActions = exports.ThemeActions || (exports.ThemeActions = {}));
function updateTheme(key, val) {
    return {
        type: ThemeActions.update,
        key: key,
        val: val
    };
}
exports.updateTheme = updateTheme;
//# sourceMappingURL=theme.js.map